module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/CentralJuvie-5_BW-p-1080-d2a8d3b243b1fafe5ba4d88c86231b6d.jpg";